import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, Alert, Heading } from '@printdeal/ui-library';
import { Link as GatsbyLink } from 'gatsby';

import useSystemPages from '../../../../../hooks/useSystemPages';

import Head from '../../../../PrivateHead';
import { getConfiguration } from '../../../../../helpers/Configuration';
import QuotesBreadCrumbs from './QuotesBreadCrumbs';
import QuoteForm from './QuotesForm';

const QuotesCreatePage = () => {
  const intl = useIntl();
  const [accountDashboard] = useSystemPages('accountDashboard');
  const configuration = getConfiguration();

  if (!configuration?.quote?.enabled) {
    return (
      <Alert variant="error"><FormattedMessage id="account.quotes.accessrestricted" defaultMessage="Access is restricted" /> </Alert>
    );
  }

  return (
    <div className="data-sentry-block">
      <Head title={intl.formatMessage({ id: 'account.quotes.form.pageTitle', defaultMessage: 'Request a quote' })} />

      <div className="pd-flex pd-flex-col pd-gap-6">
        <QuotesBreadCrumbs />
        <Heading>
          <FormattedMessage
            id="account.quotes.form.titleLabel"
            defaultMessage="Request a non-binding quote"
          />
        </Heading>
        <QuoteForm />
        <Link
          as={GatsbyLink}
          to={`${accountDashboard?.path}/quoting`}
          variant="secondary"
          iconBefore="chevron-left"
        >
          <FormattedMessage id="account.quotes.backToMyQuotes" defaultMessage="Back to My quotes" />
        </Link>

      </div>

    </div>
  );
};

export default QuotesCreatePage;
